import { api } from './api';

// ─── Admin dashboard ────────────────────────────────────────────────────
export const adminDashboardService = {
  getOverview: (windowDays = 30) =>
    api.get('/api/admin/dashboard/overview', { params: { windowDays } }).then((res) => res.data),

  getAuthenticationVolume: (period = '7d', extra = {}) =>
    api.get('/api/admin/dashboard/authentication', { params: { period, ...extra } }).then((res) => res.data),

  getAuthenticationMethods: (period = '30d', extra = {}) =>
    api.get('/api/admin/dashboard/authentication-methods', { params: { period, ...extra } }).then((res) => res.data),

  getAuthenticationStatus: (period = '30d', extra = {}) =>
    api.get('/api/admin/dashboard/authentication-status', { params: { period, ...extra } }).then((res) => res.data),

  getTopBusinesses: (period = '30d', page = 1, limit = 10) =>
    api.get('/api/admin/dashboard/businesses', { params: { period, page, limit } }).then((res) => res.data),

  getBusinessDrilldown: (businessId, period = '30d') =>
    api.get(`/api/admin/dashboard/businesses/${businessId}`, { params: { period } }).then((res) => res.data),

  getApplications: (page = 1, limit = 10, search = '') =>
    api.get('/api/admin/dashboard/applications', { params: { page, limit, search } }).then((res) => res.data),

  getApplicationDrilldown: (appId, period = '30d') =>
    api.get(`/api/admin/dashboard/applications/${appId}`, { params: { period } }).then((res) => res.data),

  getDevices: (period = '30d') =>
    api.get('/api/admin/dashboard/devices', { params: { period } }).then((res) => res.data),

  getSecurity: (windowDays = 30) =>
    api.get('/api/admin/dashboard/security', { params: { windowDays } }).then((res) => res.data),

  sendChatMessage: (message) =>
    api.post('/api/admin/dashboard/chat', { message }).then((res) => res.data),
};

// ─── Business dashboard ─────────────────────────────────────────────────
export const businessDashboardService = {
  getOverview: (applicationId = null, windowDays = 30) =>
    api
      .get('/api/business/dashboard/overview', { params: { applicationId: applicationId || undefined, windowDays } })
      .then((res) => res.data),

  getAuthenticationVolume: (period = '7d', applicationId = null, extra = {}) =>
    api
      .get('/api/business/dashboard/authentication', {
        params: { period, applicationId: applicationId || undefined, ...extra },
      })
      .then((res) => res.data),

  getAuthenticationMethods: (period = '30d', applicationId = null, extra = {}) =>
    api
      .get('/api/business/dashboard/authentication-methods', {
        params: { period, applicationId: applicationId || undefined, ...extra },
      })
      .then((res) => res.data),

  getAuthenticationStatus: (period = '30d', applicationId = null, extra = {}) =>
    api
      .get('/api/business/dashboard/authentication-status', {
        params: { period, applicationId: applicationId || undefined, ...extra },
      })
      .then((res) => res.data),

  getSubscribers: (applicationId = null) =>
    api
      .get('/api/business/dashboard/subscribers', { params: { applicationId: applicationId || undefined } })
      .then((res) => res.data),

  getDevices: (period = '30d', applicationId = null) =>
    api
      .get('/api/business/dashboard/devices', { params: { period, applicationId: applicationId || undefined } })
      .then((res) => res.data),

  getPasskeys: (period = '90d', applicationId = null) =>
    api
      .get('/api/business/dashboard/passkeys', { params: { period, applicationId: applicationId || undefined } })
      .then((res) => res.data),

  getApplications: (page = 1, limit = 10) =>
    api.get('/api/business/dashboard/applications', { params: { page, limit } }).then((res) => res.data),

  sendChatMessage: (message, applicationId = null) =>
    api
      .post('/api/business/dashboard/chat', { message }, { params: { applicationId: applicationId || undefined } })
      .then((res) => res.data),
};
